module.exports = __webpack_public_path__ + "img/bg.15c560a2.jpg";